module.exports = require("next/dist/client/components/static-generation-async-storage.external.js");